import PropTypes from "prop-types";
import React from "react";

import { PageGrid } from "@swa-ui/core";
import { CalendarFormField, Form, SubmitFormField } from "@swa-ui/form";
import {
  AutocompleteStationsFormField,
  AutocompleteVacationDestinationsFormField,
} from "@swa-ui/itinerary";

import { useVacationsFormLogic } from "../useVacationsFormLogic";
import { PackageOptions } from "./PackageOptions";
import { PromoCode } from "./PromoCode";
import { TravelerSelector } from "./TravelerSelector";
import styles from "./VacationsBookingFormWide.module.scss";

export const VacationsBookingFormWide = (props) => {
  const { defaultFormDataOverride = {} } = props;
  const { defaultSubmitButtonText, formProps } = useVacationsFormLogic({
    defaultFormDataOverride,
  });
  const {
    departureDateProps,
    destinationAirportCodeProps,
    formComponentProps,
    originationAirportCodeProps,
    packageOptionsProps,
    promoCodeProps,
    returnDateProps,
    submitButtonProps,
    travelerSelectorProps,
  } = formProps;

  return (
    <PageGrid className={styles.layout}>
      <Form {...formComponentProps}>
        <PackageOptions className={styles.package} {...packageOptionsProps} />
        <TravelerSelector className={styles.travelers} {...travelerSelectorProps} />
        <PromoCode className={styles.promo} {...promoCodeProps} />
        <PageGrid className={styles.formInputs}>
          <AutocompleteStationsFormField {...getOriginationFormFieldProps()} />
          <AutocompleteVacationDestinationsFormField {...getDestinationFormFieldProps()} />
          <CalendarFormField className={styles.departureDate} {...departureDateProps} />
          <CalendarFormField className={styles.returnDate} {...returnDateProps} />
        </PageGrid>
        <div className={styles.submit}>
          <SubmitFormField className={styles.submitButton} {...submitButtonProps}>
            {defaultSubmitButtonText}
          </SubmitFormField>
        </div>
      </Form>
    </PageGrid>
  );

  function getDestinationFormFieldProps() {
    return {
      ...destinationAirportCodeProps,
      className: styles.destinationAirportCode,
    };
  }

  function getOriginationFormFieldProps() {
    return {
      ...originationAirportCodeProps,
      className: styles.originationAirportCode,
    };
  }
};

VacationsBookingFormWide.propTypes = {
  /** Consumers of this component can optionally set default values for form fields using this prop.
   * For example, a static page driven by WCM data could use this prop. */
  defaultFormDataOverride: PropTypes.object,
};
